export { LoaderComponent } from './loader.component';
